export const SITE_URL = 'https://www.minware.com';

export const ORG_ID = `${SITE_URL}/#org`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

// The product, as one SoftwareApplication node shared by every page that describes it (the home
// page, and the pricing page with its offers), so search and answer engines see a single entity.
export const SOFTWARE_ID = `${SITE_URL}/#software`;
export const SOFTWARE_DESCRIPTION = 'minware is the engineering productivity platform that gives '
  + 'you ready-to-work actions ranked by impact to eliminate wasted tokens and human time.';

// Shipped site-wide from Layout so that page-level nodes (e.g. on /pricing)
// can reference these by @id without duplicating them.
export const orgAndWebsiteGraph = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': ORG_ID,
      name: 'minware',
      legalName: 'minware, Inc.',
      url: `${SITE_URL}/`,
      logo: {
        '@type': 'ImageObject',
        url: `${SITE_URL}/img/minware-logo-icon.png`,
        width: 512,
        height: 512,
      },
      description: 'minware makes the engineering productivity platform that gives teams '
        + 'ready-to-work actions ranked by impact to eliminate wasted tokens and human time.',
      // Third-party profiles, so search and answer engines can tie them to this organization.
      sameAs: [
        'https://www.linkedin.com/company/minware',
        'https://github.com/minwareco',
        'https://www.g2.com/products/minware',
        'https://www.gartner.com/reviews/product/minware-1203044677',
      ],
      foundingDate: '2022-06-07',
      foundingLocation: {
        '@type': 'Place',
        name: 'Arlington, VA',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Arlington',
          addressRegion: 'VA',
          addressCountry: 'US',
        },
      },
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Arlington',
        addressRegion: 'VA',
        addressCountry: 'US',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'sales',
        url: `${SITE_URL}/contact`,
      },
    },
    {
      '@type': 'WebSite',
      '@id': WEBSITE_ID,
      url: `${SITE_URL}/`,
      name: 'minware',
      publisher: { '@id': ORG_ID },
      inLanguage: 'en',
    },
  ],
};
